// extracted by mini-css-extract-plugin
export var container = "PageContent-module--container--3XcgR";
export var containerWide = "PageContent-module--containerWide--HtKVS";
export var imageText = "PageContent-module--imageText--SnNmn";
export var imageTextImg = "PageContent-module--imageTextImg--tq2m8";
export var imageTextText = "PageContent-module--imageTextText--mQFGm";
export var lineLink = "PageContent-module--line-link--87ySY";
export var lineLink_black = "PageContent-module--line-link_black--8quI9";
export var lineLink_grey = "PageContent-module--line-link_grey--zWqNn";
export var lineLink_primary = "PageContent-module--line-link_primary--WlbJp";
export var lineLink_secondary = "PageContent-module--line-link_secondary--S16NQ";
export var lineLink_white = "PageContent-module--line-link_white--g-4ao";
export var section = "PageContent-module--section--jEs09";
export var textBlock = "PageContent-module--textBlock--XNbyX";